import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { BonusesSection } from './components/BonusesSection';
import { BenefitsSection } from './components/BenefitsSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Testimonials } from './components/Testimonials';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
const PIXEL_ID = '2226605141499138';
export function App() {
  useEffect(() => {
    if (window.fbq) return;
    const n: any = window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const first = document.getElementsByTagName('script')[0];
    first?.parentNode?.insertBefore(script, first);
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen w-full bg-canvas font-sans text-ink selection:bg-accent-soft" data-id="element-0" data-mp="33mowttnqsqql">
      <noscript data-id="element-1" data-mp="38lrq6gud18iq">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="38l8j5v6904jh" />
      </noscript>

      <Hero data-id="element-3" data-mp="nuhhkgf627t8" />
      <main data-id="element-4" data-mp="nuraabrlit2m">
        <ProblemSection data-id="element-5" data-mp="nvas7sh8xhgn" />
        <SolutionSection data-id="element-6" data-mp="sunby4ctm8f0" />
        <BonusesSection data-id="element-7" data-mp="su427axbqqc2" />
        <BenefitsSection data-id="element-8" data-mp="stc6m03q8sls" />
        <OfferSection data-id="element-9" data-mp="swqaxdvybbvv" />
        <GuaranteeSection data-id="element-10" data-mp="36hzjfpzb85g" />
        <Testimonials data-id="element-11" data-mp="35ovimiemwr0" />
        <FAQSection data-id="element-12" data-mp="34x0pdwmt31s" />
        <FinalCTA data-id="element-13" data-mp="38kw6ilmzzj5" />
      </main>
      <Footer data-id="element-14" data-mp="3ud1dv4v0xg8i" />
      <PurchasePopup data-id="element-15" data-mp="3udkn7x6lywax" />
    </div>;
}